import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { listWineTypes } from 'redux/productFilters/actions';

class WineTypeFilter extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;
    const queryObj = queryString.parse(location.search);
    this.state = {
      wineType: queryObj.wineType
    };
  }

  componentDidMount() {
    this.listWineTypes();
  }

  componentDidUpdate(prevProps) {
    const { props } = this;
    if (prevProps.match.params.slug !== props.match.params.slug) {
      this.listWineTypes();
    }
  }

  listWineTypes = () => {
    const { props } = this;
    const { slug } = props.match.params;
    props.listWineTypes(slug);
  };

  handleChange = (e) => {
    const wineType = e.target.value;
    this.setState({ wineType });
    this.handleQueryChange(wineType);
  };

  handleQueryChange = (wineType) => {
    const { location, history } = this.props;
    const parsed = queryString.parse(location.search);
    if (wineType === '') {
      delete parsed.wineType;
    } else {
      parsed.wineType = wineType;
    }
    delete parsed.page;
    const stringified = queryString.stringify(parsed);
    let url = location.pathname;
    if (stringified.length > 0) {
      url += `?${stringified}`;
    }
    history.push(url);
  };

  render() {
    const { wineTypes } = this.props;
    const { wineType } = this.state;
    if (wineTypes.length === 0) {
      return null;
    }
    return (
      <>
        <div className="c7-selectbox">
          <label htmlFor="wineType">
            Type:
            <span className="c7-selectboxWrap">
              <select
                id="wineType"
                name="wineType"
                value={wineType}
                onChange={this.handleChange}
              >
                <option value="" />
                {wineTypes.map((wt) => (
                  <option value={wt.wineType} key={wt.wineType}>
                    {wt.wineType}
                  </option>
                ))}
              </select>
            </span>
          </label>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  wineTypes: state.productFilter.wineTypes
});

export default withRouter(
  connect(mapStateToProps, { listWineTypes })(WineTypeFilter)
);
